<template>
  <div>
    <c-table
      ref="table"
      :title="imprTabInfo.gridItem.title"
      :columns="gridItemColumns"
      :gridHeight="gridHeight"
      :data="gridItemData"
      :merge="imprTabInfo.gridItem.merge"
      :filtering="false"
      :columnSetting="false"
      :usePaging="false"
      :editable="!imprTabInfo.disabled"
    >
      <template v-slot:customArea="{ props }">
        <template v-if="props.row['sopImprovementIds'] && props.row['ibmStepNames']">
          <q-chip
            v-for="(item, index) in $comm.ibmTagItems(props.row)"
            :key="index"
            :color="item.color"
            outline square
            :clickable="true"
            text-color="white"
            style="margin-bottom:4px !important;"
            @click="linkClick(props.row, item.ibmClassCd, item.sopImprovementId, 'item')">
            {{item.title}}
            <c-assess-tooltip 
              :ibmTooltip="item.ibmTooltip"
              :ibmClassCd="item.ibmClassCd"
            />
          </q-chip>
        </template>
      </template>
    </c-table>
    <c-table
      ref="gridOther"
      :title="imprTabInfo.gridOther.title"
      :columns="gridOther.columns"
      :data="gridOther.data"
      :gridHeight="gridHeight"
      :usePaging="false"
      :filtering="false"
      :columnSetting="false"
      @linkClick="(row, col, idx) => linkClick(row, row.ibmClassCd, row.sopImprovementId, 'other')"
    >
      <template slot="table-button">
        <q-btn-group outline >
            <!-- 개선요청 -->
          <c-btn 
            v-if="!imprTabInfo.disabled&&imprTabInfo.isOld" 
            label="LBLIMPRREQUEST" 
            icon="add" 
            @btnClicked="addImpr" />
            <!-- 즉시조치 -->
          <c-btn 
            v-if="!imprTabInfo.disabled&&imprTabInfo.isOld" 
            label="LBLIMMEDIATE" 
            icon="add" 
            @btnClicked="addImmImpr" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
export default {
  name: 'imprTab',
  props: {
    imprTabInfo: {
      type: Object,
      default: () => ({
        key: '', // 
        ibmTaskTypeCd: '',
        ibmTaskUnderTypeCd: '',
        requestContents: '',
        disabled: false,
        isOld: false,
        isTable: false,
        gridItem: {
          listUrl: '',
          param: null, 
          title: 'LBL0001423', // 항목 별 개선사항 목록
          data: [],
          merge: [],
          columns: [],
          research: {
            impr: '',
            item: '',
          },
        },
        gridOther: {
          title: 'LBL0001424', // 항목외 개선 목록
        },
      }),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    contentHeight: null,
  },
  data() {
    return {
      gridItem: {
        data: [],
      },
      gridOther: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: 'LBLPLANT',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'ibmClassName',
            field: 'ibmClassName',
            // 구분
            label: 'LBL0001961',
            align: 'center',
            style: 'width:80px',
            sortable: false,
          },
          {
            name: 'actionDeptName',
            field: 'actionDeptName',
            // 조치부서
            label: 'LBL0001417',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'ibmTitle',
            field: 'ibmTitle',
            // 제목
            label: 'LBLTITLE',
            align: 'left',
            style: 'width:300px',
            sortable: false,
            type: 'link',
          },
          {
            name: 'actionContents',
            field: 'actionContents',
            // 조치내용
            label: 'LBL0001404',
            align: 'left',
            style: 'width:400px',
            sortable: false,
          },
          {
            name: 'actionCompleteDate',
            field: 'actionCompleteDate',
            // 조치완료일
            label: 'LBL0001405',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
        ],
        data: [],
      },
      requestImprRow: null,
      editable: true,
      impListUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '80%',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  watch: {
    'imprTabInfo.gridItem.research.impr'() {
      this.getList();
    }
  },
  computed: {
    gridHeight() {
      return this.contentHeight && (this.contentHeight - 480) > 380 ? String(this.contentHeight - 480) + 'px' : '380px';
    },
    gridItemColumns() {
      let cols = []
      if (!this.imprTabInfo.isTable) {
        // 개선/진행상태
        cols = [
          {
            name: 'customCol',
            field: 'customCol',
            label: 'LBL0002006',
            align: 'center',
            style: 'width:200px',
            type: 'custom',
            sortable: false
          }
        ]
      } else {
        cols = [
          {
            name: 'ibmTitle',
            field: 'ibmTitle',
            label: 'LBLTITLE',
            align: 'left',
            type: 'link',
            style: 'width:300px',
            sortable: true,
          },
          {
            name: 'ibmStepCd',
            field: 'ibmStepCd',
            label: 'LBLPROGRESS',
            align: 'center',
            style: 'width:100px',
            sortable: false
          },
          {
            name: 'improveRequest',
            field: 'improveRequest',
            // 요청부서정보
            label: 'LBL0001016',
            align: 'center',
            style: 'width:250px',
            sortable: true,
          },
          {
            name: 'actionCompleteRequestDate',
            field: 'actionCompleteRequestDate',
            // 조치완료요청일
            label: 'LBL0001017',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'actionDeptName',
            field: 'actionDeptName',
            // 조치부서
            label: 'LBL0001018',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
        ]
      }
      return this.$_.concat(this.imprTabInfo.gridItem.columns, cols)
    },
    gridItemData() {
      return this.imprTabInfo.gridItem.data && this.imprTabInfo.gridItem.data.length > 0 
        ? this.imprTabInfo.gridItem.data : this.gridItem.data
    }
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.impListUrl = selectConfig.sop.ibm.improve.others.url;
      // code setting
      // list setting
      this.getList();
      this.getImprList();
    },
    getList() {
      if (this.imprTabInfo.gridItem.listUrl) {
        this.$http.url = this.imprTabInfo.gridItem.listUrl;
        this.$http.type = 'GET';
        this.$http.param = this.imprTabInfo.gridItem.param
        this.$http.request((_result) => {
          this.gridItem.data = _result.data;
        },);
      }
    },
    getImprList() {
      if (this.imprTabInfo.key) {
        this.$http.url = this.impListUrl;
        this.$http.param = {
          ibmTaskTypeCd: this.imprTabInfo.ibmTaskTypeCd, 
          ibmTaskUnderTypeCd: this.imprTabInfo.ibmTaskUnderTypeCd, 
          relationTableKey: this.imprTabInfo.key
        };
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.gridOther.data = _result.data;
        },);
      }
    },
    /* eslint-disable no-unused-vars */
    linkClick(row, ibmClassCd, sopImprovementId, flag) {
      if (ibmClassCd === 'IC00000001') {
        this.popupOptions.title = 'LBLIMPROVE';
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprDetail.vue'}`);
      } else {
        this.popupOptions.title = 'LBLIMMEDIATE';
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmDetail.vue'}`);
      }
      this.popupOptions.param = {
        sopImprovementId: sopImprovementId,
      };
      this.popupOptions.width = '80%';
      this.popupOptions.visible = true;
      if (flag === 'item') {
        this.requestImprRow = row
        this.popupOptions.closeCallback = this.closeImprPopup;
      } else {
        this.popupOptions.closeCallback = this.closeImprOtherPopup;
      }
    },
    closeImprPopup(result, flag) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (result && result.col1) {
        if (this.imprTabInfo.gridItem.research) {
          this.$set(this.imprTabInfo.gridItem.research, 'item', uid())
        }
        if (flag !== 'delete') {
          let splitId = this.$_.split(this.requestImprRow.sopImprovementIds, ',');
          let splitStep = this.$_.split(this.requestImprRow.ibmStepNames, ',');
          if (splitId && splitId.length > 0) {
            let idIndex = this.$_.indexOf(splitId, result.col1.sopImprovementId);
            splitStep[idIndex] = result.col1.ibmStepName;
            this.requestImprRow.ibmStepNames = splitStep.toString();
          }
        } else {
          let splitId = this.$_.split(this.requestImprRow.sopImprovementIds, ',');
          let splitStep = this.$_.split(this.requestImprRow.ibmStepNames, ',');
          let splitClass = this.$_.split(this.requestImprRow.ibmClassCds, ',');
          let splitTooltip = this.$_.split(this.requestImprRow.ibmTooltip, '│');
          if (splitId && splitId.length > 0) {
            let idIndex = this.$_.indexOf(splitId, result.col1.sopImprovementId);
            splitId.splice(idIndex, 1)
            splitStep.splice(idIndex, 1)
            splitClass.splice(idIndex, 1)
            splitTooltip.splice(idIndex, 1)
            this.$set(this.requestImprRow, 'sopImprovementIds', splitId.toString())
            this.$set(this.requestImprRow, 'ibmStepNames', splitStep.toString())
            this.$set(this.requestImprRow, 'ibmClassCds', splitClass.toString())
            this.$set(this.requestImprRow, 'ibmTooltip', splitTooltip.join('│'))
          }
        }
        this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
        this.getList();
      }
    },
    closeImprOtherPopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      this.getImprList();
    },
    /* eslint-disable no-unused-vars */
    addImpr() {
      this.popupOptions.title = 'LBLIMPRREQUEST';
      this.popupOptions.param = {
        requestContents: this.imprTabInfo.requestContents,
        relationTableKey: this.imprTabInfo.key,
        ibmTaskTypeCd: this.imprTabInfo.ibmTaskTypeCd,
        ibmTaskUnderTypeCd: this.imprTabInfo.ibmTaskUnderTypeCd,
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprDetail.vue'}`);
      this.popupOptions.width = '80%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeAddImprPopup;
    },
    addImmImpr() {
      this.popupOptions.title = 'LBLIMMEDIATE';
      this.popupOptions.param = {
        requestContents: this.imprTabInfo.requestContents,
        relationTableKey: this.imprTabInfo.key,
        ibmTaskTypeCd: this.imprTabInfo.ibmTaskTypeCd,
        ibmTaskUnderTypeCd: this.imprTabInfo.ibmTaskUnderTypeCd,
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmDetail.vue'}`);
      this.popupOptions.width = '80%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeAddImprPopup;
    },
    closeAddImprPopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getImprList();
    }
  }
};
</script>
